import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../services/analytics";

const PAGE_TITLES = {
  "/": "Home",
  "/how-it-works": "How It Works",
  "/cookie-policy": "Cookie Policy",
  "/privacy-policy": "Privacy Policy",
  "/terms": "Terms of Service",
  "/terms-of-service": "Terms of Service",
  "/autism-support": "Autism Support",
  "/elder-care": "Elder Care",
  "/family-care": "Family Care",
  "/login": "Login",
  "/register": "Register",
  "/forgot-password": "Forgot Password",
  "/about": "About",
  "/contact-us": "Contact Us",
  "/dashboard": "Dashboard",
  "/sources": "Source History",
  "/care-team": "Care Team",
  "/sensory": "Sensory",
  "/log": "Log",
  "/therapy-notes": "Therapy Notes",
  "/templates": "Templates",
  "/medical": "Medical",
  "/medical-log/doctor-visits": "Doctor Visits",
  "/providers": "Providers",
  "/profile": "Profile",
  "/children/new": "Add Child",
  "/children/edit": "Edit Child",
  "/children/:childId/edit": "Edit Child",
  "/children/review": "Child Review",
  "/children/:childId/review": "Child Review",
  "/review-import": "Review Import",
  "/therapy-prep": "Visit Prep",
  "/children/:childId/therapy-prep": "Visit Prep",
  "/messages": "Messages",
  "/admin": "Admin",
  "/admin/natural-capture-debug": "Natural Capture Debug",
  "/admin/raw-capture-extractor": "Raw Capture Extractor",
  "/invitation/:invitationId": "Invitation",
  "/accept-invite": "Accept Invite",
  "/invite": "Invite",
  "/invite/caregiver": "Invite Caregiver",
  "/invite/carepartner": "Invite Care Partner",
  "/invite/therapist": "Invite Therapist",
  "/invite/success": "Invite Success",
};

const normalizePagePath = (pathname) => {
  if (/^\/children\/[^/]+\/edit$/.test(pathname)) {
    return "/children/:childId/edit";
  }

  if (/^\/children\/[^/]+\/review$/.test(pathname)) {
    return "/children/:childId/review";
  }

  if (/^\/children\/[^/]+\/therapy-prep$/.test(pathname)) {
    return "/children/:childId/therapy-prep";
  }

  if (/^\/invitation\/[^/]+$/.test(pathname)) {
    return "/invitation/:invitationId";
  }

  return pathname;
};

const AnalyticsRouteTracker = () => {
  const location = useLocation();
  const lastTrackedPathRef = useRef("");

  useEffect(() => {
    const path = normalizePagePath(location.pathname);

    if (lastTrackedPathRef.current === path) {
      return;
    }

    lastTrackedPathRef.current = path;
    trackPageView({
      path,
      title: PAGE_TITLES[path] || "Lifelog",
    });
  }, [location.pathname]);

  return null;
};

export default AnalyticsRouteTracker;
